import CountDownTimer from "./modules/CountDownTimer";
import SearchModal from "./modules/SearchModal";
import CustomBundles from "./modules/RechargeBundles";

new CountDownTimer;
new SearchModal;
new CustomBundles;